/* Controller Imports */
import angular from 'angular';
import ManageInviteViewRevokeModalController from './manage-invites/view/revoke-modal/revoke.controller';
import {ManageInvitesListComponent} from './manage-invites/list/list.controller';
import ManageInvitesRepository from './manage-invites/view.service';
import ManageInvitesViewController from './manage-invites/view/view.controller';
import InviteUserController from './invite-user/invite.controller';
import UserViewDeleteModalController from './users/view/delete-modal/delete.modal.controller';
import UserViewDetailsController from './users/view/view.controller';
import UserViewDetailsEditController from './users/view/edit/edit.controller';
import UserViewListController from './users/list/list.controller';

const userManagementModule = angular
  .module('app.userManagement', ['ui.bootstrap', 'ui.router', 'gettext'])
  .component('manageInvites', ManageInvitesListComponent)
  .controller('ManageInvitesViewController', ManageInvitesViewController)
  .controller('ManageInviteViewRevokeModalController', ManageInviteViewRevokeModalController)
  .factory('manageInvitesRepository', ManageInvitesRepository)
  .controller('InviteUserController', InviteUserController)
  .controller('UserViewDeleteModalController', UserViewDeleteModalController)
  .controller('UserViewDetailsController', UserViewDetailsController)
  .controller('UserViewDetailsEditController', UserViewDetailsEditController)
  .controller('UserViewListController', UserViewListController);
export default userManagementModule.name;
